import bundledHistory from './history.json';

export type Release = {
  version: string;
  date: string;
  title: string;
  changes: { kind: 'new' | 'improved' | 'fixed'; text: string }[];
  commit: string;
};

// The release command injects this file into its isolated build. Never fetch a
// newer manifest into an older running application: notes must match its code.
export function releaseForDisplay(release: Release): Release {
  const productName = (text: string) => text
    .replace(/CAP4Publish erstatter navnet Publisher/gi, 'Navnet CAP4Publish bruges nu')
    .replace(/(?:CAP4\s*)?Publisher\b/gi, 'CAP4Publish');
  return {...release, title: productName(release.title), changes: release.changes.map(change => ({...change, text: productName(change.text)}))};
}
// Preserve the published record; only its presentation follows the current name.
export const releases = (bundledHistory as Release[]).map(releaseForDisplay);
export function versionLabel(version: string) {
  return `${version === '0.1.0' ? '0.1' : version} Beta`;
}
export function isNewer(version: string, seen: unknown): boolean {
  if (typeof seen !== 'string' || !/^\d+\.\d+\.\d+$/.test(seen)) return true;
  const a = version.split('.').map(Number), b = seen.split('.').map(Number);
  for (let i = 0; i < 3; i++) if (a[i] !== b[i]) return a[i] > b[i];
  return false;
}
